<div class="container d-print-none">

    <div class="row justify-content-center">

        <ng-container *ngIf="list_Trip.length;else noResult">

            <div class="col-md-6 col-12 mt-3">

                <div class="card mb-3 shadow-sm" *ngFor="let item of list_Trip" (click)="openDetails(item)">

                    <div class="card-body pointer" style="background-color: #f1f5f9;">

                        <div class="d-flex justify-content-between align-items-center mb-3">

                            <span class="badge bg-gray text-dark fs-3">{{ item?.iEmdadRo | faNum }}</span>

                            <div class="d-flex align-items-center gap-2">

                                <div class="d-flex flex-column">

                                    <span class="badge bg-success" style="width: fit-content;">

                                        {{ item?.strReason4Request_strComment }} - {{
                                        item?.strReliefRequestType_strComment
                                        }}

                                    </span>

                                    <span class="badge mt-2" style="width: fit-content;"
                                        [ngClass]="item.tiTripStatus == 8 ? 'bg-danger' : item.tiTripStatus == 2 ? 'bg-warning text-dark' : 'bg-info text-dark' ">

                                        {{ item?.strTaxiLon_TripStatus_strComment }}

                                    </span>

                                </div>

                            </div>

                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-3">

                            <div class="d-flex flex-column">

                                <span class="d-flex align-items-center justify-content-between">

                                    <mat-icon class="d-flex align-items-center ps-2">calendar_month</mat-icon>

                                    {{ item?.strTime | faNum }} - {{ item?.strDate | faNum }}

                                </span>

                            </div>

                        </div>

                        <div class="d-flex justify-content-between align-items-center">

                            <span *ngIf="item?.iAdvancePayment !== 0" class="text-success">

                                پیش پرداخت :

                                <b> {{ item?.iAdvancePayment | number: '1.0-0' | faNum }} ریال</b>

                            </span>

                        </div>

                        <!-- آدرس مبداء -->

                        <div class="d-flex justify-content-between align-items-center">
                            <span *ngIf="item?.strSAddress != ''" class="text-muted">
                                آدرس مبداء:
                                <b> {{ item?.strSAddress | faNum }} </b>
                            </span>
                        </div>

                        <!-- آدرس مقصد -->

                        <div *ngIf="item?.strDAddress != ''"
                            class="d-flex justify-content-between align-items-center mt-2">
                            <span class="text-muted">
                                آدرس مقصد:
                                <b> {{ item?.strDAddress | faNum }} </b>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-template #noResult>

            <div class="not-found p-2">

                <img src="../../../../assets/imgs/no-results.png" alt="در حال حاضر درخواست فعالی ندارید!">

                <p class="my-3">در حال حاضر درخواست فعالی ندارید!</p>

                <button class="btn btn-success" routerLink="/new-request"> درخواست حمل </button>

            </div>

        </ng-template>

    </div>

</div>

<div class="modal d-print-none fade dir " id="details" tabindex="4" role="dialog" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content bg-gray-soft" style="direction: rtl;max-height:100%;">
            <div class="modal-header d-flex justify-content-between border-0">
                <button type="button" class="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
                <span>کد : <b class="text-danger">{{postDetail?.iEmdadRo | faNum}}</b></span>
                <span (click)="goBack()" *ngIf="modalMode !== 1" class="d-flex">
                    <mat-icon>arrow_back</mat-icon>
                </span>
            </div>

            <div class="modal-body" style="overflow-y: auto;">

                <ng-container *ngIf="modalMode == 1">

                    <div class="trip_detail central flex-column">

                        <div class="central trip_status py-3">

                            <h4>{{postDetail?.strTaxiLon_TripStatus_strComment}} ! </h4>

                        </div>

                        <!-- تصویر قبل و بعد -->

                        <div *ngIf="postDetail?.strBefore_Image" class="row gx-0 gy-0 w-100">

                            <!-- تصویر قبل از یدک کشی -->

                            <div class="col-12 col-md-6 p-1" (click)="showImage(0)">

                                <img class="w-100 pointer" style="max-height: 100px;object-fit: cover;"
                                    src="{{ postDetail?.strBefore_Image != '' ? 'data:image/png;base64,' + postDetail?.strBefore_Image : '../../../../assets/imgs/preview__thumbnail.png' }}"
                                    alt="تصویر قبل از یدک کشی">

                                <p class="mt-2 text-center"> تصویر قبل از یدک کشی </p>

                            </div>

                            <!-- تصویر بعد از یدک کشی -->

                            <div class="col-12 col-md-6 p-1" (click)="showImage(1)">

                                <img class="w-100 pointer" style="max-height: 100px;object-fit: cover;"
                                    src="{{ postDetail?.strAfter_Image != '' ? 'data:image/png;base64,' + postDetail?.strAfter_Image : '../../../../assets/imgs/preview__thumbnail.png' }}"
                                    alt="تصویر بعد از یدک کشی">

                                <p class="mt-2 text-center"> تصویر بعد از یدک کشی </p>

                            </div>

                        </div>

                        <div *ngIf="postDetail?.tiTripStatus == 8" class="central flex-column trip_point py-1 dil">

                            <div *ngIf="postDetail?.tiDriverPoints == 1">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>

                            <div *ngIf="postDetail?.tiDriverPoints == 2">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>

                            <div *ngIf="postDetail?.tiDriverPoints == 3">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>

                            <div *ngIf="postDetail?.tiDriverPoints == 4">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>

                            <div *ngIf="postDetail?.tiDriverPoints == 5">
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>

                        </div>

                    </div>

                    <div class="central flex-column detailbox">

                        <ng-container *ngIf="postDetail?.tiTripStatus >= 3 && postDetail?.tiTripStatus <= 8">

                            <div class="driver_box">

                                <div class="central justify-content-between">

                                    <b>

                                        {{ postDetail?.strDriver_FullName | faNum}}

                                        - {{ postDetail?.strDriver_Mobile | faNum }}

                                    </b>


                                    <img *ngIf="postDetail?.strAvatar"
                                        src="data:image/png;base64,{{postDetail?.strAvatar}}" alt="profile">
                                    <img *ngIf="!postDetail?.strAvatar"
                                        src="../../../../assets/imgs/avatar-default-icon.png" alt="profile">
                                </div>

                                <div class="central justify-content-between flex-wrap mt-2">

                                    <div class="col-12 col-md-6 ">
                                        <b class="w">
                                            {{postDetail?.strMobileGroup_strComment |faNum}} ،
                                            {{postDetail?.strGPSType_strComment |faNum}} -
                                            {{postDetail?.strColor |faNum}}
                                        </b>
                                    </div>

                                    <div class="col-12 col-md-6 mb-2 central justify-content-end">
                                        <taxi-plate class="" [text1]="postDetail?.strVehicleNo.split(' ')[0]"
                                            [text2]="postDetail?.strVehicleNo.split(' ')[1]"
                                            [text3]="postDetail?.strVehicleNo.split(' ')[2]"
                                            [text4]="postDetail?.strVehicleNo.split(' ')[4]">
                                        </taxi-plate>

                                    </div>

                                </div>
                            </div>

                        </ng-container>



                        <div class="central justify-content-between">
                            <span>تاریخ</span>
                            <b>{{postDetail?.strTime |faNum}} - {{postDetail?.strDate |faNum}}</b>
                        </div>
                        <div *ngIf="postDetail?.bForAnother" class="central justify-content-between">
                            <span> نام مسافر </span>
                            <b>{{postDetail?.strPassengersName | faNum}} </b>
                        </div>
                        <div class="central justify-content-start">
                            <span> آدرس مبدا: </span>
                            <address class="mb-0 fw-bold ms-auto">{{postDetail?.strSAddress|faNum}}</address>
                            <i class="fa fa-map-marker fa-lg bg-warning px-3 py-2 rounded pointer"
                                title="نمایش بر روی نقشه"
                                (click)="showMap([postDetail.fSLat,postDetail.fSLon,postDetail.strSAddress])">

                            </i>
                        </div>

                        <!-- آدرس مقصد -->

                        <ng-container *ngIf="postDetail?.strDAddress.trim() != ''">
                            <div class="central justify-content-start">
                                <span> آدرس مقصد: </span>
                                <address class="mb-0 fw-bold ms-auto">{{postDetail?.strDAddress|faNum}}</address>
                                <i *ngIf="postDetail?.fDLat != 0 && postDetail?.fDLon != 0"
                                    class="fa fa-map-marker fa-lg bg-warning px-3 py-2 rounded pointer"
                                    title="نمایش بر روی نقشه"
                                    (click)="showMap([postDetail.fDLat,postDetail.fDLon,postDetail.strDAddress])">
                                </i>
                            </div>

                        </ng-container>

                        <div *ngIf="postDetail?.bCargo" class="central justify-content-start">
                            <span> مشخصات بار : </span>
                            <b>{{postDetail?.strCargoDetail |faNum}} </b>
                        </div>
                        <div *ngIf="postDetail?.strComment !== ''" class="central justify-content-start">
                            <span> توضیحات : </span>
                            <b>{{postDetail?.strComment |faNum}} </b>
                        </div>
                        <div *ngIf="postDetail?.tiTripStatus == 10" class="central justify-content-start">
                            <span> توضیحات لغو : </span>
                            <b>{{postDetail?.strPassenger_CancelReason |faNum}} </b>
                        </div>

                        <ng-container>

                            <div class="central justify-content-between">

                                <span> ساعت شروع </span>

                                <b>{{postDetail?.strSTripTime | faNum}} </b>

                            </div>

                            <div *ngIf="postDetail?.strEndFullTime" class="central justify-content-between">

                                <span> تاریخ و ساعت پایان </span>

                                <b>{{postDetail?.strEndFullTime }} </b>

                            </div>

                            <!-- علت درخواست -->

                            <div class="central justify-content-between">

                                <span> علت درخواست </span>

                                <b>{{postDetail?.strReason4Request_strComment | faNum}} </b>

                            </div>

                            <!-- علت توقف -->

                            <div *ngIf="postDetail?.strReasonStopping" class="central justify-content-between">

                                <span> علت توقف </span>

                                <b>{{postDetail?.strReasonStopping | faNum}} </b>

                            </div>

                            <!-- نوع درخواست -->

                            <div class="central justify-content-between">

                                <span> نوع درخواست </span>

                                <b>{{postDetail?.strReliefRequestType_strComment | faNum}} </b>

                            </div>

                            <!-- نوع خودرو -->

                            <div class="central justify-content-between">

                                <span> نوع خودرو </span>

                                <b> {{ postDetail?.strMobileType_strComment | faNum }} </b>

                            </div>

                            <!-- طرح ترافیک -->

                            <div *ngIf="postDetail?.bTraffic" class="central justify-content-between">

                                <span> طرح ترافیک </span>

                                <b> {{ postDetail?.bTraffic ? '✅' : '❌' }} </b>

                            </div>

                            <!-- طرح آلودگی -->

                            <div *ngIf="!postDetail?.bTraffic && postDetail?.bEvenOdd"
                                class="central justify-content-between">

                                <span> طرح آلودگی </span>

                                <b> {{ postDetail?.bEvenOdd ? '✅' : '❌' }} </b>

                            </div>

                            <!-- شرایط آب وهوایی ویژه -->

                            <div *ngIf="postDetail?.bBadWeather" class="central justify-content-between">

                                <span> شرایط آب وهوایی ویژه </span>

                                <b> {{ postDetail?.bBadWeather ? '✅' : '❌' }} </b>

                            </div>

                            <!-- منطقه کوهستانی -->

                            <div *ngIf=" postDetail?.bMountainous" class="central justify-content-between">

                                <span> منطقه کوهستانی </span>

                                <b> {{ postDetail?.bMountainous ? '✅' : '❌' }} </b>

                            </div>

                            <!-- مسافت یدک کشی -->

                            <div class="central justify-content-between">

                                <span> مسافت یدک کشی </span>

                                <b class="text-dark"> {{ postDetail?.fFinalKm | number: '1.0-0' | faNum}}</b>

                            </div>

                            <!-- پیش پرداخت -->

                            <div class="central justify-content-between">

                                <span> پیش پرداخت </span>

                                <b>{{postDetail?.iAdvancePayment | number: '1.0-0' |faNum}} ریال</b>

                            </div>

                            <!-- تخفیف -->
                            <div *ngIf="postDetail?.iDiscount > 0" class="central justify-content-between">
                                <span> تخفیف </span>
                                <b class="text-success">{{postDetail?.iDiscount | number: '1.0-0' |faNum}} ریال</b>
                            </div>

                            <!-- هزینه کل -->

                            <div class="central justify-content-between">

                                <span> هزینه کل </span>

                                <b class="text-success">{{postDetail?.iFinalRent | number: '1.0-0' |faNum}} ریال</b>

                            </div>

                            <!-- توضیحات سایر هزینه ها -->

                            <div *ngIf="postDetail?.strOtherRentComment != ''" class="central justify-content-between">

                                <span> توضیحات سایر هزینه ها : {{ postDetail?.strOtherRentComment }} </span>

                            </div>

                        </ng-container>

                        <ng-container *ngIf="postDetail?.tiTripStatus == 8">

                            <button (click)="printInvoice()" class="central btn btn-primary bg-gray w-100 p-1">

                                <mat-icon>receipt</mat-icon>صدور فاکتور

                            </button>

                        </ng-container>

                    </div>

                    <div class="central butt_options mb-2 mt-3">
                        <button *ngIf="postDetail?.tiTripStatus == 0" class="btn btn-success" (click)="payInvoice()">
                            <mat-icon>payment</mat-icon>پرداخت
                        </button>

                        <button *ngIf="postDetail?.tiTripStatus == 8" class="btn btn-info">
                            <a class="text-dark central" target="_blank" [href]="['/route/'+ postDetail?.iEmdadRo]">
                                <i aria-hidden="true" class="fa fa-road fa-lg mx-1"></i>
                                مسیر
                            </a>
                        </button>

                        <ng-container *ngIf="postDetail?.tiTripStatus >= 3 && postDetail?.tiTripStatus <= 8">
                            <button (click)="openCancelTrip(4)" class="btn btn-outline-secondary">
                                <i aria-hidden="true" class="fa fa-file-text-o fa-lg mx-1"></i>
                                مدارک
                            </button>
                        </ng-container>

                        <button (click)="openCancelTrip(3)"
                            *ngIf="postDetail?.tiTripStatus == 8 && postDetail?.tiDriverPoints == 0"
                            class="btn btn-primary ">
                            <mat-icon>star</mat-icon>امتیاز
                        </button>

                        <button (click)="openCancelTrip(2)" *ngIf="postDetail?.tiTripStatus <= 6"
                            class="btn btn-danger">
                            <mat-icon>clear</mat-icon>لغو
                        </button>
                    </div>

                </ng-container>

                <ng-container *ngIf="modalMode == 2">

                    <div class="form-group w-100 has-icon mb-3">

                        <label class="text-danger text-large m-0 mb-1"> دلیل لغو </label>


                        <span class="form-control-icon">

                            <mat-icon class="mat-18">comment</mat-icon>

                        </span>

                        <textarea style="height:75px;" type="text" class="w-100 mb-3 form-control border-red"
                            [(ngModel)]="strPassenger_CancelReason" placeholder="نوشتن دلیل الزامی است"></textarea>


                    </div>

                    <div class=" central w-100 justify-content-between price_offer">
                        <div class="w-100 mx-1">
                            <button (click)="goBack()" class="w-100 btn btn-third px-4">
                                انصراف </button>
                        </div>
                        <div class="w-100 mx-1">
                            <button (click)="cancelTrip(postDetail?.iEmdadRo)" class="w-100 btn btn-primary px-4">
                                ثبت
                            </button>
                        </div>
                    </div>

                </ng-container>

                <ng-container *ngIf="modalMode == 3">

                    <span class="central text-large">

                        لطفا میزان رضایت خود از را وارد نمایید

                    </span>

                    <div class="my-3">
                        <star-rating [starType]="'svg'" [rating]="0" (ratingChange)="onRatingChange($event)">
                        </star-rating>
                    </div>

                    <div class="central justify-content-evenly mb-3 d-none">
                        <span>کمترین</span>
                        <img style="width: 100px;mix-blend-mode: darken;" src="../../../../assets/imgs/arrow_left.png"
                            alt="">
                        <span>بیشترین</span>
                    </div>

                    <ng-container *ngIf="currentRating != ''">

                        <div class="p-1 mb-3">

                            <textarea class="w-100 form-control" style="height: 100px;"
                                placeholder="متن نظر خود را وارد کنید..."
                                [(ngModel)]="currentRating.strPassengerOpinion">


                            </textarea>

                        </div>

                    </ng-container>

                    <div class=" central w-100 justify-content-between price_offer">
                        <div class="w-100 mx-1">
                            <button (click)="setTripRate(postDetail?.iEmdadRo)" class="w-100 btn btn-primary px-4">
                                ثبت
                            </button>
                        </div>
                        <div class="w-100 mx-1">
                            <button (click)="goBack()" class="w-100 btn btn-outline-secondary px-4">
                                انصراف </button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="modalMode == 4">
                    <div class="row">
                        <div class="col-6" *ngFor="let item of driverEvidence">
                            <div class="central justify-content-between flex-column evidence_box"
                                (click)="openDetailsimg(item)">
                                <img width="100" *ngIf="item?.strImage" src="data:image/png;base64,{{item?.strImage}}"
                                    alt="profile">

                                <span>
                                    {{item?.strEvidenceType_strComment}}
                                </span>

                            </div>
                        </div>
                    </div>


                </ng-container>

            </div>

        </div>

    </div>

</div>

<!-- مدال نقشه -->
<app-custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value"
    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true" [skip_Search]="true"
    [isShowFooter]="false" (mdl_Submit)="showCustom_Map=false">

</app-custom-map>

<!-- پرینت -->
<div class="modal d-print-none fade dir " id="detailsimg" tabindex="4" role="dialog" aria-hidden="true">

    <div class="h-100 image-modal modal-dialog modal-lg modal-dialog-centered">

        <div class="h-100 modal-content bg-gray-soft" style="direction: rtl;">

            <div class="modal-header d-flex justify-content-between border-0 p-0">



                <button type="button" class="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="h-100 modal-body central">

                <img class="" src="data:image/png;base64,{{mainImg}}" alt="profile">

            </div>

        </div>

    </div>

</div>

<!-- فاکتور سرویس -->
<div class="Invoice-container print-display row gx-0 gy-0 p-2">

    <div class="col-4 d-flex flex-column align-items-center justify-content-center py-2">

        <img src="../../../../assets/imgs/Shahrnik_Logo_Public_new.png" alt="">

        <p class="fw-bold my-2" style="font-size: 14px;">سامانه خدمات امداد خودرو و جرثقیل سیار</p>

        <p class="fw-bold" style="font-size: 16px;"> www.emdadran.com </p>

    </div>

    <div class="col-8 row gx-0 gy-2 p-2">

        <div class="col-6"> شماره : {{ postDetail?.iEmdadRo | faNum }} </div>

        <div class="col-6"> تاریخ : {{ postDetail?.strDate | faNum }} </div>

        <div class="col-6"> نام درخواست دهنده :

            {{ postDetail?.strFullName }}

        </div>

        <div class="col-6"> تلفن : {{ postDetail?.strMobile | faNum }} </div>

        <div class="col-6"> گروه خودرویی : {{ postDetail?.strMobileGroup_strComment }} </div>

        <div class="col-6"> راننده : {{ postDetail?.strDriver_FullName }} </div>

        <div class="col-6"> پلاک : {{ postDetail?.strVehicleNo | faNum }} </div>

        <div class="col-6"> علت درخواست : {{ postDetail?.strReason4Request_strComment | faNum }} </div>

        <div class="col-6"> نوع درخواست : {{ postDetail?.strReliefRequestType_strComment | faNum }} </div>

        <div class="col-6"> مسافت یدک کشی : {{ postDetail?.fFinalKm | faNum }} </div>

        <div class="col-6"> پیش پرداخت : {{ postDetail?.iAdvancePayment | number:'1.0-0' | faNum }} ریال </div>

        <div *ngIf="postDetail?.iDiscount > 0" class="col-6"> تخفیف : {{ postDetail?.iDiscount | number:'1.0-0' | faNum }} ریال </div>

        <div class="col-6"> هزینه نهایی : {{ postDetail?.iFinalRent | number:'1.0-0' | faNum }} ریال </div>

        <div *ngIf="postDetail?.iUsedPartsCost > 0" class="col-6"> هزینه قطعات و لوازم :

            {{ postDetail?.iUsedPartsCost | number:'1.0-0' | faNum }} ریال

        </div>

        <div *ngIf="postDetail?.iRepairCost > 0" class="col-6"> اجرت :

            {{ postDetail?.iRepairCost | number:'1.0-0' | faNum }} ریال

        </div>

        <div *ngIf="postDetail?.strOtherRentComment" class="col-12">

            توضیحات سایر هزینه ها : {{ postDetail?.strOtherRentComment}}

        </div>

        <div class="col-6" *ngIf="postDetail?.bTraffic"> طرح ترافیک : بله </div>

        <div class="col-6" *ngIf="postDetail?.bEvenOdd"> طرح آلودگی : بله </div>

        <div class="col-6" *ngIf="postDetail?.bBadWeather"> آب وهوایی ویژه : بله </div>

        <div class="col-6" *ngIf="postDetail?.bMountainous"> منطقه کوهستانی : بله </div>

        <div class="col-12"> مبداء : {{ postDetail?.strSAddress }} </div>

        <div *ngIf="postDetail?.strDAddress" class="col-12"> مقصد : {{ postDetail?.strDAddress }} </div>

        <div class="col-12" *ngIf="postDetail?.strComment.trim() != ''">

            توضیحات : "{{ postDetail?.strComment}}"

        </div>

        <div class="col-12 mt-4">

            <p class="my-2"> تلفن : {{ '2-02177273160' | faNum }} </p>

        </div>

    </div>

</div>

<!-- گالری تصاویر -->
<div class="modal fade dir" id="galleryComp_Modal" role="dialog" style="z-index: 1000!important;">

    <div class="modal-dialog modal-fullscreen modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header d-flex justify-content-between">

                <h3 class="modal-title mb-0"> گالری تصاویر </h3>

                <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal"></button>

            </div>

            <div class="modal-body">

                <ng-container *ngIf="isAlbum">

                    <custom-gallery [albumIndex]="albumIndex" [lst_Album]="lst_Album" [isDownloadAble]="false"
                        [strKey_list]="'strImage'">

                    </custom-gallery>

                </ng-container>

            </div>

        </div>

    </div>

</div>